/* eslint react/prop-types: 0, react/display-name: 0 */
import React, { lazy, Suspense } from 'react'
import PubSub from 'pubsub-js'
import { Layout } from './src/components/Layout'

import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'
import { createClient as _createPrismicClient } from '@prismicio/client'

import linkResolver from './src/core/linkResolver.js'

const repositoryConfigs = [
	{
		repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
		linkResolver: doc => linkResolver(doc),
		componentResolver: {
			home: lazy(() => import('./src/templates/page-home.jsx')),
			page: lazy(() => import('./src/templates/page-default.jsx')),
			velo: lazy(() => import('./src/templates/page-velo.jsx')),
			article: lazy(() => import('./src/templates/page-blog-post.jsx')),
			categorie_blog: lazy(() => import('./src/templates/page-blog-category.jsx')),
			categorie_velo: lazy(() => import('./src/templates/page-velos-category.jsx')),
			evenement: lazy(() => import('./src/templates/page-events.jsx')),
		},
	},
]
const _wrapRootElement = ({ element }) => {
	return (
		<PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
			<Suspense fallback={null}>
				{element}
			</Suspense>
		</PrismicPreviewProvider>
	)
}

const _wrapPageElement = ({ element, props }) => {
	// console.log(props)
	return <Layout {...props}>{element}</Layout>
}

const _onClientEntry = () => {
	// Polyfill: gatsby-plugin-prismic-previews v6 calls getCachedRepository()
	// which was renamed to getRepository() in @prismicio/client v7
	const proto = Object.getPrototypeOf(_createPrismicClient('temp'))
	if (!proto.getCachedRepository && proto.getRepository) {
		proto.getCachedRepository = proto.getRepository
	}

	document.body.classList.add('loading')
	const isTouch = 'ontouchstart' in window ? true : false

	if (isTouch) {
		document.documentElement.classList.add('touch')
	} else {
		document.documentElement.classList.add('no-touch')
	}

	window.onload = () => {
		// console.log('window.onload')

		setTimeout(() => {
			document.body.classList.remove('loading')
		}, 1000)
	}

	const delay = 4 * 60 * 1000
	// const delay = 1000
	// console.log('delay', delay)
	// const delay = 1000
	setTimeout(() => {
		PubSub.publish('SHOW_FORM')
	}, delay)
}

const _onPreRouteUpdate = ({ location, prevLocation }) => {
	// console.log(location, prevLocation)
	PubSub.publish('PRE_ROUTE_UPDATE', location)
}

const _onRouteUpdate = ({ location, prevLocation }) => {
	// console.log(location, prevLocation)
	PubSub.publish('ROUTE_UPDATE', location)
}

export {
	_wrapRootElement,
	_wrapPageElement,
	_onClientEntry,
	_onRouteUpdate,
	_onPreRouteUpdate,
}
